"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorsProhibitedListsAwarenessIsEnsured = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.DistributorsProhibitedListsAwarenessIsEnsured = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.distributors_prohibited_lists_awareness_is_ensured.label',
    fallbackLabel: 'Please confirm that you will ensure your distributors are aware and will comply with Klarna\'s list of prohibited jurisdictions.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
